<template>
    <div>

        <section class="feature-section mt-20">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 text-left">
                        <h2>Batch and Streaming</h2>
                        <p>
                          Skippr discovers, clenses, and optimises your data. Creating partitioned object stores with optimised Parquet, evolving and syncing schemas to tables and configuring your datalake.
                        </p>
                    </div>
                    <div class="col-md-7">

                        <div class="row mb-30">
                            <div v-for="(model, index) in plugins" v-bind:key="index" class="col-xs-4 col-md-3">
                                <div class="contact-box" v-on:click="clickEvent(model)">
                                    <div class="row">
                                        <div class="col-4 mb-30">
                                            <div class="text-center">

                                                <img v-bind:src="'images/plugins/data_output/' + model.name + '/logo.png'"
                                                     class="img-circle m-t-xs img-fluid"
                                                     max-width="100px"
                                                     max-height="100px"
                                                     style="
                                                max-width: 100px;
                                                max-height: 100px;
                                                padding: 12px;
                                                vertical-align: middle;
                                                background-color: #fff;
                                                box-shadow: 0 6px 20px -5px rgba(50,50,93,0.25);
                                                cursor: pointer;"
                                                />
                                                <div class="m-t-xs font-bold">{{ model.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

<!--                        <p class="text-center">-->
<!--                            <router-link to="/integrations/destinations" class="btn btn-primary btn-sm">View all Destinations</router-link>-->
<!--                        </p>-->
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'DestinationIntegrations',
        props: {

            plugins: {
                type: Array,
                default() {
                    return [
                        {name: 'AWS Athena'},
                        {name: 'S3 Bucket'},
                        {name: 'Redshift'},
                        {name: 'BigQuery'},
                        {name: 'Postgres'},
                        {name: 'Snowflake'},
                    ];
                },
            },

        },
        methods: {
            clickEvent(name) {
              this.$gtag.event('click', {
                event_category: 'data_outputs',
                event_label: name,
              })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
